import { render } from "./NotificationDocument.vue?vue&type=template&id=00393670&scoped=true&ts=true&lang=pug"
import script from "./NotificationDocument.vue?vue&type=script&lang=ts"
export * from "./NotificationDocument.vue?vue&type=script&lang=ts"

import "./NotificationDocument.vue?vue&type=style&index=0&id=00393670&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00393670"]])

export default __exports__